






















import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class CheckBox extends Vue {
  @Prop({ default: false }) value!: boolean | string;
  @Prop({ default: "" }) id!: string;
  @Prop({ default: "" }) name!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) required!: boolean;

  checked: boolean = false;

  created() {
    this.syncChecked();
  }

  @Watch("value")
  onValueChanged() {
    this.syncChecked();
  }

  syncChecked() {
    this.checked = this.value === true || this.value === "true";
  }

  @Emit("input")
  onChange(event: Event) {
    const target = event.target as HTMLInputElement | null;
    this.checked = target ? target.checked : this.checked;
    return this.checked;
  }
}
